import { useEffect } from "react";

const ORIGIN = "https://geodrafts.com";

function upsert(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export default function Seo({ title, description, path = "/", jsonLd = null, geo = null, hreflang = null, lang = null }) {
  useEffect(() => {
    document.title = title;
    if (lang) document.documentElement.lang = lang;
    else document.documentElement.lang = "en";
    upsert("name", "description", description);
    upsert("property", "og:title", title);
    upsert("property", "og:description", description);
    upsert("property", "og:url", `${ORIGIN}${path}`);
    upsert("property", "og:type", "website");
    upsert("property", "og:image", `${ORIGIN}/og-image.png`);
    upsert("name", "twitter:title", title);
    upsert("name", "twitter:description", description);
    upsert("name", "twitter:image", `${ORIGIN}/og-image.png`);

    // geo tags (region/placename) — removed when the next page doesn't set them
    document.head.querySelectorAll('meta[data-seo="geo"]').forEach((e) => e.remove());
    if (geo) {
      [
        ["geo.region", geo.region],
        ["geo.placename", geo.placename],
      ].forEach(([k, v]) => {
        const el = document.createElement("meta");
        el.setAttribute("name", k);
        el.setAttribute("content", v);
        el.setAttribute("data-seo", "geo");
        document.head.appendChild(el);
      });
    }

    // hreflang alternates — reciprocal set passed by the page
    document.head.querySelectorAll('link[data-seo="hreflang"]').forEach((e) => e.remove());
    (hreflang || []).forEach(({ lang, path: p }) => {
      const el = document.createElement("link");
      el.setAttribute("rel", "alternate");
      el.setAttribute("hreflang", lang);
      el.setAttribute("href", `${ORIGIN}${p}`);
      el.setAttribute("data-seo", "hreflang");
      document.head.appendChild(el);
    });

    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", `${ORIGIN}${path}`);

    let ld = document.getElementById("page-jsonld");
    if (jsonLd) {
      if (!ld) {
        ld = document.createElement("script");
        ld.id = "page-jsonld";
        ld.type = "application/ld+json";
        document.head.appendChild(ld);
      }
      ld.textContent = JSON.stringify(jsonLd);
    } else if (ld) {
      ld.remove();
    }
  }, [title, description, path, jsonLd, geo, hreflang, lang]);

  return null;
}
